var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":this.$store.state.browserSize.width <= _vm.standard ?
      '/images/logo/logo-rebless-vertical.svg': '/images/logo/logo-rebless.svg',"alt":"logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }